module.exports = __webpack_public_path__ + "img/credit_3.9162c76a.jpg";